import type { Chart } from 'features/charts-v2/types'
import { ALIAS_FOR_NULL_VALUES } from 'src/constants/filter-values'

/**
 * Counts distinct primary-breakdown values (`category[0]`) — the number of
 * rows actually rendered on the chart, as opposed to `chart.data.length`,
 * which is the number of wire rows (one per breakdown-value *tuple*, e.g.
 * 36 brands x 3 sentiments = 108 wire rows for 36 rendered bars).
 *
 * Callers must pass a chart that has already gone through
 * `selectGroupedChartData` (e.g. `sortedDisplayData` / `aliasedDisplayData`)
 * so that a grouping toggle's `parent_data` swap is reflected here too.
 *
 * Null/empty `category[0]` values collapse into a single bucket, matching
 * the backend's own null-consolidation (see charts-v2/AGENTS.md).
 */
export const countParentRows = (chart: Chart | null | undefined): number => {
  if (!chart?.data.length) return 0

  const parentValues = new Set(
    chart.data.map((item) => {
      const value = item.category[0]
      return value === null || value === undefined || value === ''
        ? ALIAS_FOR_NULL_VALUES
        : String(value)
    }),
  )
  return parentValues.size
}
